import * as tooltip from '@zag-js/tooltip';
import { normalizeProps, useMachine } from '@zag-js/solid';
import { createMemo, createUniqueId, Show } from 'solid-js';

export function Tooltip(props) {
  const delay = props.delay ?? { show: 300, hide: 100 };
  const service = useMachine(tooltip.machine, {
    id: createUniqueId(),
    openDelay: delay.show,
    closeDelay: delay.hide,
    positioning: { placement: props.placement ?? 'top' },
  });

  const api = createMemo(() => tooltip.connect(service, normalizeProps));

  return (
    <div>
      <div {...api().getTriggerProps()}>{props.children}</div>
      <Show when={api().open}>
        <div {...api().getPositionerProps()}>
          <div {...api().getContentProps()}>{props.content}</div>
        </div>
      </Show>
    </div>
  );
}
